import EquationValue, {
  variables,
  VariableType,
} from "../../../Model/Value/EquationValue"
import RandomNumberGenerator from "../../RandomNumberGenerator"
import NumberValue from "../../../Model/Value/NumberValue"
import ValueGeneratorInterface from "../ValueGeneratorInterface"

export default class SumEquationValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(): boolean {
    return true
  }

  generate(x: number): EquationValue {
    const a: number = this.randomNumberGenerator.randomInt(1, x * 3 - 1)
    const templates: string[] = ["a + x = b", "x + a = b"]
    const b: number = a + x

    return new EquationValue(
      new NumberValue(a),
      new NumberValue(x),
      new NumberValue(b),
      this.randomNumberGenerator.pick<VariableType>(variables),
      this.randomNumberGenerator.pick<string>(templates),
    )
  }
}
